module.exports = __webpack_public_path__ + "static/media/tw.742872b8.svg";